import { useEffect, useState } from "react";

export function useScript(url, name) {
  const [lib, setLib] = useState({});

  useEffect(() => {
    // Si la URL no está configurada, no intentamos cargar ningún script.
    if (!url || !name) {
      setLib({});
      return undefined;
    }

    // Si la librería ya existe en window, no volvemos a cargarla.
    if (window[name]) {
      setLib({
        [name]: window[name],
      });

      return undefined;
    }

    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = url;
    script.async = true;

    script.onload = () => {
      if (window[name]) {
        setLib({
          [name]: window[name],
        });
      }
    };

    script.onerror = () => {
      console.error(
        `No fue posible cargar el script: ${url}`
      );
    };

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [url, name]);

  return lib;
}